<template>
  <div data-view="businesses">
    <router-view v-slot="{ Component }">
      <component :is="Component" @saved="onSaved" />
    </router-view>

    <layout-logged-frame
      :title="$t('businesses')"
      :total-count="pagination.totalItems"
    >
      <template v-slot:header-actions>
        <header-actions :actions="headerActions" />
      </template>

      <template v-slot:content>
        <BusinessesFilters @filter="onFilter" @clearFilters="onClearFilters">
          <template v-slot:phone-actions>
            <sort-by-select
              :columns="columns"
              :pagination="pagination"
              :on-update-pagination="onUpdatePagination"
            />
          </template>
        </BusinessesFilters>

        <BusinessesTable
          :on-add="addAction?.onClick"
          :add-label="addAction?.title"
          :columns="columns"
          :items="businesses"
          :pages="totalPages"
          :pagination="pagination"
          :is-loading="isLoading"
          :on-select-item="selectItem"
          :on-update-pagination="onUpdatePagination"
          :on-change-page="onChangePage"
          :sync-to-url="true"
          @init-pagination="onInitPagination"
        >
        </BusinessesTable>
      </template>
    </layout-logged-frame>
  </div>
</template>

<script>
  import BusinessesFilters from '../../components/forms/filters/Businesses';
  import columns from '../../config/businesses/columns';
  import BusinessesTable from '../../components/table/Businesses';
  import viewWithFilters from '../../mixins/viewWithFilters';

  export default {
    mixins: [viewWithFilters],
    components: {
      BusinessesFilters,
      BusinessesTable
    },
    data() {
      return {
        columns,
        pagination: {
          order: 'desc' ,
          page: 1,
          rowsPerPage: 15,
          sortBy: 'created_at',
          totalItems: 0,
          search: '',
        },
        query: { per_page: 15 },
      };
    },
    computed: {
      addAction() {
        return this.headerActions.find(({ key, isDisabled }) => key === 'add' && !isDisabled);
      },
      headerActions() {
        return [
          this.$ability.can('store', 'business') && {
            key: 'add',
            title: this.$t('add_new_business'),
            onClick: () => this.$router.push({ name: 'businesses-new', query: this.$route.query }),
          },
        ].filter(Boolean);
      },
      businesses() {
        return this.$store.getters['businesses/items'];
      },
    },
    methods: {
      // Emitted by the add dialog route after a successful save. Before the dialogs
      // became child routes the save handler lived here and refetched directly —
      // this keeps the refetch in the same place, with this view's own query, and
      // out of the URL. Editing a business does not refetch: the store patches the
      // row in the listing instead (see businessUpdateAlert.spec.js).
      onSaved() {
        this.getItems(this.query);
      },
      getItems(query = {}) {
        this.isLoading = true;
        this.pagination.order = query.order;

        return this.$store
          .dispatch('businesses/getItems', query)
          .then((res) => {
            const { itemsMeta } = this.$store.getters['businesses/itemsData'];
            const { total, current_page, last_page } = itemsMeta;

            this.pagination.page = current_page;
            this.pagination.totalItems = total;
            this.totalPages = last_page;
            this.isLoading = false;

            return res;
          })
          .catch((err) => {
            this.isLoading = false;
            return err;
          });
      },
      selectItem(business) {
        this.$router.push({ name: 'business-details', params: { id: business.id }, query: this.$route.query });
      },
    },
  };
</script>

<style lang="scss">
@use '../../assets/styles/theme' as *;

.v-datatable {
  min-width: $table-min-width;
}
</style>
